// Strip mid-word BOLD/UNDERLINE/ITALIC inlineStyleRanges. A range is
// considered mid-word — and dropped — when either edge sits between two
// alphanumeric characters (i.e. start splits a word, or end splits a word).
// Whole-word and multi-word ranges that terminate on whitespace or punctuation
// are preserved.
//
// Catches stray ranges (AI/paste artifacts) like BOLD{offset:0,length:3} on
// text starting with "Resting…" — the renderer would otherwise emit
// <strong>Res</strong>ting. Note: ranges covering numeric values like "0.2"
// between space and period are KEPT (clean boundaries).

const STYLES_TO_CHECK = ["BOLD", "UNDERLINE", "ITALIC"];

const isAlnum = (ch) => {
  if (!ch) return false;
  return /^[\p{L}\p{N}]$/u.test(ch);
};

const stripMidWordInlineStyles = (dataMix) => {
  if (!dataMix || !dataMix.blocks || !Array.isArray(dataMix.blocks)) return dataMix;

  dataMix.blocks = dataMix.blocks.map((block) => {
    const ranges = block && block.inlineStyleRanges;
    if (!Array.isArray(ranges) || ranges.length === 0) return block;
    const text = typeof (block && block.text) === "string" ? block.text : "";
    if (text === "") return block;
    const textLen = text.length;

    const filtered = ranges.filter((r) => {
      if (!r) return false;
      const style = r.style;
      if (!STYLES_TO_CHECK.includes(style)) return true;
      const offset = typeof r.offset === "number" ? r.offset : -1;
      const length = typeof r.length === "number" ? r.length : 0;
      if (length <= 0 || offset < 0 || offset >= textLen) return true;
      const end = Math.min(offset + length, textLen);

      if (offset > 0) {
        const charBefore = text.charAt(offset - 1);
        const charAtStart = text.charAt(offset);
        if (isAlnum(charBefore) && isAlnum(charAtStart)) return false;
      }
      if (end < textLen) {
        const charAtEndMinus = text.charAt(end - 1);
        const charAtEnd = text.charAt(end);
        if (isAlnum(charAtEndMinus) && isAlnum(charAtEnd)) return false;
      }
      return true;
    });

    return { ...block, inlineStyleRanges: filtered };
  });

  return dataMix;
};

export default stripMidWordInlineStyles;
